import React, { useEffect } from 'react';
import {
  Form,
  Button,
  Divider,
} from "antd";
import { Skeleton } from 'antd';
import { useNavigate, useParams } from "react-router-dom";
import { handleLogin } from "../security/ToggleViews";


export const LoginView = () => {
  const params = useParams();
  const navigate = useNavigate();


  let path1 = '/register';
  let path2 = '/nys/frequently-asked-questions';

  // useEffect(() => {
  //   redirect();
  // }, [])

  // const redirect = () => {
  //   if (params.key) {
  //     let path = `/nys/candidate/details/${params.key}`;
  //     navigate(path);
  //   }
  // }

  return (
    <>
      <div className="login-pf-page">
        <div class="register-container">
          <div class="card-pf register-left">
            <img className="img-register-login" src={require("../assets/login-illustration.png")} />
          </div>
          <div className="card-pf register-right">
            {/* <img class="nys-logo" src="/resources/um98p/login/nys-app/img/NYS-logo-without-background.png"> */}
            {/* <img className="nys-logo-register" src={require("../assets/seims-logo.png")} /> */}
            <header className="login-pf-header">
              <h1 id="kc-page-title">Login / Register</h1>
            </header>
            <div id="kc-content">
              <div id="kc-content-wrapper">
                <h4>If you alreay have a SEIMS account, please select Login. If you do not have an account, please select Register.</h4>
                <div id="kc-form">
                  <div id="kc-form-wrapper">
                    <Form.Item style={{ marginBottom: 15 }}>
                      <Button
                        type="primary"
                        className="pf-c-button pf-m-primary pf-m-block btn-lg register-form-buttons"
                        onClick={() => navigate(path1)}>Register</Button>
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 15 }}>
                      <Button
                        type="primary"
                        className="pf-c-button pf-m-primary pf-m-block btn-lg register-form-buttons"
                        // style={{ marginLeft: 10 }} 
                        onClick={handleLogin}>
                        Login
                      </Button>
                    </Form.Item>
                    {/* <Form.Item style={{ marginBottom: 0 }}>
                      <Button
                        type="primary"
                        className="pf-c-button pf-m-primary pf-m-block btn-lg register-form-buttons"
                        // style={{ marginLeft: 10 }} 
                        onClick={() => navigate(path2)}>
                        FAQ
                      </Button>
                    </Form.Item> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
